<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  metaInfo: {
    title: 'لایوی - نمایش زنده جهان',
    htmlAttrs: { lang: 'fa', dir: 'rtl' },
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'لایوی، پوشش جامع اخبار زنده جهان و نمایش لحظه‌ای رویدادها روی نقشه.'
      }
    ]
  }
}
</script>

<style>
  @font-face {
    font-family: Vazirmatn;
    font-style: normal;
    font-weight: normal;
    src: url('assets/fonts/vazir/Vazirmatn.woff2') format('woff2');
  }
</style>

<style lang="scss">
  @import "@/assets/css/app.scss";
  @import "@/assets/css/styles.scss";
  @import "@/assets/fonts/font-awesome.min.css";
</style>
